define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/IconProperty",
        "../properties/QuickAccessIconProperty",
        "../properties/IconOverrideProperty",
        "../properties/TextProperty",
        "../properties/TextOverrideProperty",
        "../properties/EnabledProperty",
        "../properties/DescriptionProperty",
        "../properties/DescriptionOverrideProperty",
        "../properties/MnemonicProperty",
        "../properties/ShortcutProperty",
        "../properties/ActionIdProperty",
        "../properties/IsInQABProperty",
        "../properties/PopupIdProperty",
        "../properties/PreventRestoreFocusProperty",
        "../properties/HasDynamicPopupProperty",
        "../properties/ErrorTextProperty",
        "../properties/WarningTextProperty",
        "../properties/ValidationStateProperty"
    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, IconProperty, QuickAccessIconProperty,
              IconOverrideProperty, TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty,
              DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty, IsInQABProperty,
              PopupIdProperty, PreventRestoreFocusProperty, HasDynamicPopupProperty, ErrorTextProperty, WarningTextProperty,
              ValidationStateProperty) {
        var hash = {};

        hash[TypeConstants.DROP_DOWN_BUTTON] = lang.mixin({}, TypeProperty, TagProperty, IconProperty,
            QuickAccessIconProperty, IconOverrideProperty, TextProperty, TextOverrideProperty, EnabledProperty,
            DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
            IsInQABProperty, PopupIdProperty, PreventRestoreFocusProperty, HasDynamicPopupProperty, ErrorTextProperty, WarningTextProperty,
            ValidationStateProperty);

        return hash;
    });

